export enum ProductType {
	Flight = 'Air',
	Hotel = 'Hotel',
	Activity = 'Activity',
	Assistance = 'Assistance',
	Car = 'Car',
	Disney = 'Plan',
	HotelDisney = 'HotelDisney',
}
